import {
  DAVINCI_EVENT_NAMES,
} from '../davinci/davinciConstants';
import {
  TRACKER_TYPES,
} from '../analyticsConstants';

import {
  HBUS_READY_EVENT,
} from './hbusConstants';

let queuedRequestContexts = [];
let isInitialPageLoadEventFired = false;

function queueRequest(eventName, eventData) {
  queuedRequestContexts.push(
    {
      eventName,
      eventData,
    }
  );
}

function triggerQueuedEvents() {
  if (queuedRequestContexts) {
    queuedRequestContexts.forEach(
      ({eventName, eventData}) => {
        trackEvent(eventName, eventData);
      }
    );
  }
}

function trackEvent(eventName, eventData) {
  if (process.env.BROWSER && window) {
    if (eventName === DAVINCI_EVENT_NAMES.PAGE_LOAD && !isInitialPageLoadEventFired) {
      isInitialPageLoadEventFired = true;
      window.hepsiBus.send(TRACKER_TYPES.DAVINCI, eventName, {
        ...eventData,
        ...window.additionalInitialDavinciPageLoadEventData,
      });
    } else {
      window.hepsiBus.send(TRACKER_TYPES.DAVINCI, eventName, eventData);
    }
  }
}

const hbusApiClient = {
  sendEventRequest(eventName, eventData) {
    return new Promise((resolve, reject) => {
      if (process.env.BROWSER && window && window?.hepsiBus) {
        trackEvent(eventName, eventData);
      } else {
        queueRequest(eventName, eventData);
      }

      resolve({data: {}});
    });
  },

  sendMultiEventRequest(eventArray) {
    const promises = eventArray.map(event => {
      return this.sendEventRequest(event?.eventName, event?.eventData)
    })
    return Promise.all(promises)
  },
};

if (process.env.BROWSER && window.addEventListener) {
  window?.addEventListener(
    HBUS_READY_EVENT,
    function () {
      if (process.env.BROWSER && window?.hepsiBus) {
        triggerQueuedEvents();
      } else {
        queuedRequestContexts = null;
      }
    }
  );
}

export default hbusApiClient;
